<template>
  <div class="buypoints">
    <!-- <top-nav ref="TopNav"></top-nav>
    <van-nav-bar :title="title" fixed>
      <van-icon
        slot="left"
        class="iconfont icon-zuojiantou"
        style="font-size: .25rem"
        @click="goBack"
      ></van-icon>
      <van-icon slot="right" class="iconfont icon-zhankai" @click="onClickRight()"></van-icon>
    </van-nav-bar> -->
    <GlobTopNav :title="title" :rightHidden="false"></GlobTopNav>

    <div class="buypoints-bg"></div>

    <div class="van-content">
      <div v-if="plan == 1">
        <div class="nicknameCont">
          <span>购买数量</span>
          <van-field v-model="pointsNum" placeholder="请输入要购买的值" />
        </div>
        <!-- <p class="ft12 col-999" style="padding: 0 0.15rem">单位：{{ unit }}</p> -->

        <div class="next">
          <van-button size="large" :disabled="isbut" class="next-btn" @click="next()">
            下一步
          </van-button>
          <p class="text-cent">
            <router-link to="/user/buypoints/detail">{{ unit }}购买记录</router-link>
          </p>
        </div>
      </div>

      <div class="part2" v-if="plan == 2">
        <div class="part2-item">
          <div class="pointCont">
            <p>
              购买{{ unit }}：
              <span>{{ pointsNum }}{{ unit }}</span>
            </p>
            <p>
              支付金额：
              <span class="theme-col">{{ money }}元</span>
            </p>
          </div>
          <div class="cell-content">
            支付方式：
            <span>微信支付</span>
            <img src="./../../../assets/img/wxzf.svg" alt="" />
          </div>
        </div>
        <van-button class="pay" @click="comit()">去支付</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '../../../components/topnav'
import md5 from 'js-md5'
export default {
  name: 'index',
  components: { TopNav },
  data() {
    return {
      pointsNum: this.$route.params.points,
      plan: 1,
      money: 0,
      title: '',
      isbut: 'disabled'
    }
  },
  watch: {
    pointsNum(val) {
      this.pointsNum = this.pointsNum.replace(/[^\d]+|(^0)+/g, '')
      if (this.pointsNum == 0 || this.pointsNum == undefined) {
        this.isbut = 'disabled'
      } else {
        this.isbut = false
      }
    }
  },
  computed: {
    unit: function () {
      return this.$store.state.unitinfo.name
    }
  },
  methods: {
    goBack: function () {
      history.back(-1)
    },
    toast: function () {
      this.$dialog
        .alert({
          title: '提示',
          message: '请先到个人中心绑定微信账号！'
        })
        .then(() => {
          // on close
        })
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay()
    },
    next: function () {
      if (this.pointsNum == 0 || this.pointsNum == undefined) {
        this.$dialog
          .alert({
            title: '提示',
            message: '积分值不能为空！'
          })
          .then(() => {
            // on close
          })
      } else {
        var p = localStorage.getItem('point')
        var num1 = this.pointsNum / p
        var result2 = Math.ceil(num1 * 100) / 100
        var h = result2.toFixed(2)
        this.money = h
        this.plan = 2
      }
    },
    comit: function () {
      var isUser = localStorage.getItem('BLHuser')
      var mallid = localStorage.getItem('mallid')
      var root = process.env.PAY_URL
      this.$api.post(
        '/user/wechat/newPoint',
        { id_example: mallid, token_user: isUser, point: this.pointsNum },
        res => {
          if (res.data.code == '100') {
            var backurl = window.location.origin + '/pointsucceed?id=' + res.data.data.id
            backurl = encodeURIComponent(backurl)
            window.location.href = root + '?id=' + res.data.data.id + '&reurl=' + backurl
          }
        }
      )
    }
  },
  mounted() {
    if (this.$route.params.points > 0) {
      this.isbut = false
    }
    var unit = localStorage.getItem('unit')
    var unitname = '购买' + unit
    this.title = unitname
  }
}
</script>

<style lang="less" scoped>
.buypoints {
  width: 100%;
  height: 100vh;
  background-color: #f5f5f5;

  .buypoints-bg {
    width: 100%;
    height: 3.3rem;
    background: linear-gradient(133deg, #ffffff 0%, #f3e1d0 100%);
    position: absolute;
    top: 0;
  }

  .van-content {
    position: relative;
    z-index: 1;
    width: calc(100% - 0.6rem);
    height: 4.76rem;
    background: #ffffff;
    border-radius: 0.24rem;
    margin: 0 auto;
    overflow: hidden;
    margin-top: 1.4rem;
    padding: 0.4rem 0.1rem;
    box-sizing: border-box;

    .nicknameCont {
      height: 1.18rem;
      display: flex;
      border-bottom: 0.01rem solid #f5f5f5;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 0.48rem;

      span {
        display: block;
        width: 1.5rem;
        font-size: 0.28rem;
        font-weight: bold;
        color: rgba(38, 38, 38, 0.8);
        line-height: 0.48rem;
      }

      .van-field {
        padding-left: 0.6rem;
      }
    }

    .next {
      margin-top: 0.62rem;

      .next-btn {
        width: calc(100% - 0.2rem);
        height: 0.96rem;
        margin-left: 0.1rem;
        background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
        border-radius: 0.48rem;
        font-size: 0.3rem;
        font-weight: 500;
        color: #ffffff;
        line-height: 0.42rem;
      }

      .text-cent {
        margin-top: 0.6rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: #025bff;
        line-height: 0.4rem;
        text-align: center;
      }
    }

    .part2 {
      .part2-item {
        .pointCont {
          border-bottom: 0.02rem solid #f5f5f5;
          p {
            font-size: 0.28rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(38, 38, 38, 0.5);
            line-height: 0.48rem;
            padding: 0 0.3rem;
            margin-bottom: 0.2rem;

            span {
              color: #262626;
            }
          }
        }

        .cell-content {
          font-size: 0.28rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(38, 38, 38, 0.5);
          line-height: 0.48rem;
          padding: 0 0.3rem;
          margin-top: 0.28rem;
          display: flex;
          align-items: center;

          span {
            color: #262626;
          }

          img {
            width: .4rem;
            height: .4rem;
            margin-left: 0.1rem;
          }
        }
      }

      .pay {
        width: calc(100% - 0.4rem);
        height: 0.96rem;
        background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
        border-radius: 0.48rem;
        margin-left: 0.2rem;
        margin-top: 0.68rem;
        font-size: 0.3rem;
        font-weight: 500;
        color: #ffffff;
        line-height: 0.42rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/buypoints/index.vue